import React from "react";
import Button from "../../../components/CustomButtons/Button";
import localization from "../../../config/localization";
import browserHistory from "../../../utils/browserHistory";
import {isNullOrUndefined} from "util";

class ErrorPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorText: props.errorText || localization.get('error.too_many_attempts'),
      showButton: !isNullOrUndefined(props.showButton) ? props.showButton : true,
    }
  }

  render = () => {
    return (
      <div style={{width: "100%", height:"100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column"}}>
          <p style={{textAlign:"center",fontSize: 50, padding: "0 10%", lineHeight: 1}}>{this.state.errorText}</p>
          {!!this.state.showButton && <Button round size="sm" style={{textAlign: "center"}} onClick={() => browserHistory.goBack()}>{localization.get('go_back')} </Button>}
      </div>
    )}
}


export default ErrorPage;
